<div fxLayout="column" fxFlexFill style="position: relative">
  <div fxLayout="column" fxFlexFill class="spinner-container" *ngIf="dataSource.loading$ | async">
    <mat-spinner></mat-spinner>
  </div>
  <div fxFlex="auto" fxFlexFill class="table-container">
    <mat-table
      [dataSource]="dataSource"
      multiTemplateDataRows
      class="regular-table responsive"
      matSort
      matSortActive="createdOn"
      matSortDirection="desc"
      matSortDisableClear
    >
      <ng-container matColumnDef="eventType">
        <mat-header-cell *matHeaderCellDef mat-sort-header="eventType">Type</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Type:</span>
          <span>
            {{ row.eventType }}
          </span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="direction">
        <mat-header-cell *matHeaderCellDef mat-sort-header="direction">Direction</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Direction:</span>
          <span>
            {{ row.direction == 'in' ? 'Incoming' : 'Outgoing' }}
          </span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="createdOn">
        <mat-header-cell *matHeaderCellDef mat-sort-header="createdOn">Date</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Date:</span>
          <span>
            {{ row.createdOn | dateTime: 'M/dd/yyyy hh:mm a' }}
          </span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="tnFrom">
        <mat-header-cell *matHeaderCellDef mat-sort-header="tnFrom">From</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">From:</span>
          <span> {{ row.tnFrom | phoneNumber }} {{ row.direction == 'in' ? row.contactName : '' }} </span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="tnTo">
        <mat-header-cell *matHeaderCellDef mat-sort-header="tnTo">To</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">To:</span>
          <span> {{ row.tnTo | phoneNumber }} {{ row.direction == 'out' ? row.contactName : '' }} </span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="deliveryDescription">
        <mat-header-cell *matHeaderCellDef mat-sort-header="deliveryDescription">Status</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Status:</span>
          <span>
            <span>{{ row.state }}</span>
            <span *ngIf="additionalFilter.type === 'failed'"> - {{ row.deliveryDescription }}</span>
          </span>
          {{ row.status }}
        </mat-cell>
      </ng-container>

      <ng-container *ngIf="isSendByVisible | async" matColumnDef="sendBy">
        <mat-header-cell *matHeaderCellDef mat-sort-header="sendBy">Send By</mat-header-cell>
        <mat-cell *matCellDef="let row">
          {{ row.sendBy }}
        </mat-cell>
      </ng-container>

      <!-- Header and Row Declarations -->
      <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns" class="call-logs-row"></mat-row>
    </mat-table>
  </div>
  <mat-paginator fxFlex="initial" [length]="dataSource.dataCount$ | async" [pageSize]="100"></mat-paginator>
</div>
